var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [!_vm.$vuetify.breakpoint.mobile ? _c('main-slide') : _c('v-carousel', {
    staticClass: "main-slide",
    attrs: {
      "height": "auto",
      "hide-delimiters": "",
      "show-arrows-on-hover": "",
      "cycle": _vm.cycle
    },
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, _vm._l(_vm.banners, function (banner, index) {
    return _c('v-carousel-item', {
      key: index,
      attrs: {
        "ripple": false
      }
    }, [banner.open ? _c('v-img', {
      attrs: {
        "src": banner.src,
        "width": "100%",
        "contain": "",
        "aspect-ratio": 640 / 820
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.open(banner.open);
        }
      }
    }) : _vm._e(), banner.to ? _c('router-link', {
      attrs: {
        "to": banner.to
      }
    }, [_c('v-img', {
      attrs: {
        "src": banner.src,
        "width": "100%",
        "contain": "",
        "aspect-ratio": 640 / 820
      }
    })], 1) : _vm._e(), !banner.to && !banner.open ? _c('v-img', {
      attrs: {
        "src": banner.src,
        "width": "100%",
        "contain": "",
        "aspect-ratio": 640 / 820
      }
    }) : _vm._e()], 1);
  }), 1), _c('v-container', {
    staticClass: "px-0 px-lg-12px"
  }, [_c('main-profile'), _c('main-button-group')], 1), _c('section', {
    staticClass: "main-section best-seller"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("베스트 셀러")])]), _c('product-list', {
    staticClass: "main-product-list",
    attrs: {
      "skin": "main",
      "is-best": "",
      "is-recommend": "",
      "category-code": "bestseller",
      "limit": "6"
    }
  })], 1)], 1), _c('section', {
    staticClass: "main-section",
    staticStyle: {
      "background-color": "#f9f9f9"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("제휴 상품")])]), _c('partners-slide')], 1)], 1)], 1), _c('popup-layer', {
    attrs: {
      "code": "main"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }